import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from './dialog';
import { GradientButton } from './GradientButton';
import { useTranslation } from 'react-i18next';

export const DialogForm = ({ 
  triggerText, 
  title, 
  description, 
  onSubmit, 
  buttonStyle = "gradient" 
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await onSubmit(e);
      setShowThankYou(true);
      e.target.reset();
    } catch (error) {
      console.error('Form submission error:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const getTriggerButton = () => {
    if (buttonStyle === "black") {
      return (
        <button className="px-8 py-4 text-lg font-bold text-white bg-black hover:bg-neutral-900 
          rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200">
          {triggerText}
        </button>
      );
    }
    
    return (
      <GradientButton className="px-8 py-4 text-lg font-bold text-white bg-gradient-to-r from-purple-500 to-indigo-500 
        rounded-lg shadow-lg transform hover:scale-110 hover:from-purple-600 hover:to-indigo-600 transition-transform duration-200">
        {triggerText}
      </GradientButton>
    );
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        {getTriggerButton()}
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-center">{title}</DialogTitle>
          <p className="text-center text-gray-600 mt-2">{description}</p>
        </DialogHeader>

        {showThankYou ? (
          <div className="text-center py-8">
            <h3 className="text-xl font-semibold text-green-600 mb-2">Thank You!</h3>
            <p className="text-gray-600">We'll be in touch soon to schedule your demo.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4 py-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                {t('App.contact_name')}
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-violet-500 focus:ring-violet-500"
              />
            </div>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                {t('App.contact_email')}
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-violet-500 focus:ring-violet-500"
              />
            </div>
            <div>
              <label htmlFor="company" className="block text-sm font-medium text-gray-700">
                {t('App.contact_company')}
              </label>
              <input
                type="text"
                id="company"
                name="company"
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-violet-500 focus:ring-violet-500"
              />
            </div>
            <div>
              <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                {t('App.contact_what')}
              </label>
              <textarea
                id="message"
                name="message"
                rows={4}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-violet-500 focus:ring-violet-500"
              />
            </div>
            <div className="flex justify-center">
              {buttonStyle === "black" ? (
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-8 py-4 text-lg font-bold text-white bg-black hover:bg-neutral-900 
                    rounded-lg shadow-lg transform hover:scale-105 transition-all duration-200 
                    disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    {isSubmitting ? t('App.sending') : t('App.submit_request')}
                </button>
              ) : (
                <GradientButton
                  type="submit"
                  disabled={isSubmitting}
                  className="px-8 py-4 text-lg font-bold text-white bg-gradient-to-r from-purple-500 to-indigo-500 
                    rounded-lg shadow-lg transform hover:scale-110 hover:from-purple-600 hover:to-indigo-600 
                    transition-transform duration-200"
                >
                    {isSubmitting ? t('App.sending') : t('App.submit_request')}
                    </GradientButton>
              )}
            </div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
};
